import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FeedbackForm from "./feedback_form";
import TermsOfService from "./terms_of_service";
import PrivacyPolicy from "./privacy_policy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/feedbackform" element={<FeedbackForm />} />
        <Route
          path="/privacypolicy"
          element={<PrivacyPolicy appName="露營地資訊小幫手" />}
        />
        <Route
          path="/termsofservice"
          element={<TermsOfService appName="露營地資訊小幫手" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
